module.exports = __webpack_public_path__ + "static/media/tv-filled-black.6f247ed0.svg";